import React from "react";

const steps = [
  {
    number: 1,
    title: "Open Square Developer Console",
    description: (
      <>
        Open{" "}
        <a
          href="https://developer.squareup.com/console/en/apps"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary-500 hover:underline font-medium"
        >
          developer.squareup.com/console/en/apps
        </a>{" "}
        and log in with your credentials. Merchants need to sign in here to retrieve an access token for Wam Bam registration.
      </>
    ),
    images: [{ src: "./../../images/step1.png", alt: "Square Developer Console login screen" }],
  },
  {
    number: 2,
    title: "Skip the optional prompt (if shown)",
    description: (
      <>
        If you see the screen below, click <strong>Remind me next time</strong> &gt; <strong>Continue to Square</strong>.
      </>
    ),
    images: [
      { src: "./../../images/step2.png", alt: "Optional skip screen" },
      { src: "./../../images/step3.png", alt: "Continue to Square" },
    ],
  },
  {
    number: 3,
    title: "Access your Developer Dashboard",
    description: (
      <>
        After signing in, you'll see your Developer Dashboard. Click the <strong>Open</strong> button under the Wam Bam application.
      </>
    ),
    images: [{ src: "./../../images/step4.png", alt: "Developer dashboard with Open button" }],
  },
  {
    number: 4,
    title: "Copy your Sandbox Access Token",
    description: (
      <>
        After clicking <strong>Open</strong>, find your <strong>Sandbox access token</strong>. Click <strong>Show</strong> to reveal it, then copy it to use when registering as a merchant in Wam Bam.
        <br />
        <span className="text-gray-400 text-xs mt-1 block">
          * You can also use your <strong>production access token</strong> to join with your live store.
        </span>
      </>
    ),
    images: [
      { src: "./../../images/step5.png", alt: "Access token reveal screen" },
      { src: "./../../images/step6.png", alt: "Access token copy screen" },
    ],
  },
];

const SignupGuide = () => {
  return (
    <div className="min-h-screen bg-gray-50 pt-16">
      {/* Page Header */}
      <div className="bg-white border-b border-gray-100 px-8 py-8">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            How to Find Your Square Access Token
          </h1>
          <p className="text-gray-500 text-base">
            Follow these steps to locate your access key and complete your Wam Bam merchant registration.
          </p>
        </div>
      </div>

      {/* Steps */}
      <div className="max-w-3xl mx-auto px-8 py-10">
        <div className="flex flex-col gap-6">
          {steps.map((step) => (
            <div
              key={step.number}
              className="bg-white rounded-2xl border border-gray-100 shadow-card overflow-hidden"
            >
              <div className="px-8 pt-7 pb-5">
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-8 h-8 bg-primary-500 rounded-full flex items-center justify-center text-white font-bold text-sm flex-shrink-0 mt-0.5">
                    {step.number}
                  </div>
                  <div>
                    <h2 className="text-base font-semibold text-gray-900 mb-1">{step.title}</h2>
                    <p className="text-sm text-gray-600 leading-relaxed">{step.description}</p>
                  </div>
                </div>
              </div>
              {step.images.length > 0 && (
                <div className="px-8 pb-7 flex flex-col gap-4">
                  {step.images.map((img, i) => (
                    <img
                      key={i}
                      src={img.src}
                      alt={img.alt}
                      className="w-full rounded-xl border border-gray-100 shadow-sm object-contain"
                    />
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-8 bg-primary-50 border border-primary-100 rounded-2xl px-8 py-6">
          <p className="text-sm text-primary-700 font-medium">
            Once you have your access token, return to the sign-up form and paste it in the <strong>Access Token</strong> field.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignupGuide;
